export default {
  install (Vue) {
    const $tools = {

      expoMode () {
        return window.location.href.indexOf('expo-') > -1
      },

      isMobile () {
        return window.innerWidth < 830
      },

      isTouchDevice () {
        return (('ontouchstart' in window) ||
          ('ontouchstart' in document.documentElement) ||
          (navigator.MaxTouchPoints > 0) ||
          (navigator.msMaxTouchPoints > 0))
      },

      slugify (string) {
        const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
        const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
        const p = new RegExp(a.split('').join('|'), 'g')

        return string.toString().toLowerCase()
          .replace(/\s+/g, '-') // Replace spaces with -
          .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
          .replace(/&/g, '-and-') // Replace & with 'and'
          .replace(/[^\w-]+/g, '') // Remove all non-word characters
          .replace('-', '') // Replace multiple - with single -
          .replace(/^-+/, '') // Trim - from start of text
          .replace(/-+$/, '') // Trim - from end of text
      },

      pluralizeString (stringSingular, stringPlural, isPlural) {
        if (typeof stringSingular !== 'string' || typeof stringPlural !== 'string') {
          throw new Error('Les deux premiers arguments doivent être des chaînes de caractères.')
        }

        if (typeof isPlural !== 'boolean') {
          throw new Error('Le troisième argument doit être un booléen.')
        }

        return isPlural ? stringPlural : stringSingular
      },

      shuffleArray (arr) {
        return arr.map(a => [Math.random(), a])
          .sort((a, b) => a[0] - b[0])
          .map(a => a[1])
      },

      randomNumber (min, max) {
        return Math.floor(min + Math.random() * (max + 1 - min))
      },

      disableInteraction () {
        document.querySelector('#interaction-helper').style.display = 'block'
      },

      enableInteraction () {
        document.querySelector('#interaction-helper').style.display = 'none'
      },

      disableScroll () {
        const top = window.scrollY || document.documentElement.scrollTop
        document.body.style.top = -top + 'px'
        document.body.style.position = 'fixed'
      },

      enableScroll () {
        const top = document.body.style.top
        document.body.style.position = ''
        document.body.style.top = ''
        window.scrollTo(0, parseInt(top || '0') * -1)
      },

      limitLines (texte, lignesMax) {
      // Convertir le texte en un tableau de mots
        const mots = texte.split(' ')

        // Vérifier s'il y a plus de lignes que la limite
        if (mots.length <= lignesMax * 3) {
          return texte // Si le nombre de mots est inférieur ou égal à 3 fois le nombre de lignes, renvoyer le texte intact
        } else {
        // Sinon, tronquer le texte et ajouter des points de suspension
          const texteTronque = mots.slice(0, lignesMax * 3).join(' ')
          return texteTronque + '...'
        }
      }
    }

    Vue.prototype.$tools = $tools
    Vue.$tools = $tools
  }
}
